module.exports = __webpack_public_path__ + "static/media/1539813211021.f9516c3a.png";